export default __webpack_public_path__ + "static/media/users.b6176603.svg";